import React, { useState } from 'react';
import { Loader2, Trash2 } from 'lucide-react';
import { apiService } from '../../services/api';

// Suppression d'une réunion depuis une liste (personne qui l'a enregistrée, ou admin) : confirmation sur place.
const DeleteMeetingButton = ({ meeting, onDeleted }) => {
  const [confirming, setConfirming] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState(null);
  if (!meeting.can_delete) return null;

  const remove = async () => {
    setDeleting(true);
    setError(null);
    try {
      await apiService.delete(`/meetings/${meeting.id}`);
      onDeleted(meeting.id);
    } catch (err) {
      setError(err.message);
      setDeleting(false);
    }
  };

  if (!confirming) {
    return (
      <button type="button" onClick={() => setConfirming(true)} title="Supprimer la réunion"
        className="shrink-0 rounded-lg p-1.5 text-slate-300 hover:bg-rose-50 hover:text-rose-600">
        <Trash2 className="h-4 w-4" />
      </button>
    );
  }
  return (
    <span className="flex shrink-0 flex-wrap items-center justify-end gap-1.5 text-xs">
      {error ? <span className="text-rose-600">{error}</span> : <span className="text-slate-600">Supprimer définitivement ?</span>}
      <button type="button" onClick={remove} disabled={deleting}
        className="flex items-center gap-1 rounded-lg bg-rose-600 px-2 py-1 font-semibold text-white hover:bg-rose-700 disabled:opacity-60">
        {deleting && <Loader2 className="h-3 w-3 animate-spin" />} Supprimer
      </button>
      <button type="button" onClick={() => { setConfirming(false); setError(null); }}
        className="rounded-lg border border-slate-200 px-2 py-1 text-slate-600 hover:bg-slate-50">Annuler</button>
    </span>
  );
};

export default DeleteMeetingButton;
